/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest,
  TelegramTransactionsUserControllerCreateAndroidPaymentMutationResponse,
  TelegramTransactionsUserControllerCreateAndroidPayment400,
  TelegramTransactionsUserControllerCreateAndroidPayment401,
  TelegramTransactionsUserControllerCreateAndroidPayment404,
} from '../../types/TelegramTransactionsUserControllerCreateAndroidPayment.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsUserCreateAndroidPayment } from '../../methods/telegramTransactionsUserCreateAndroidPayment.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsUserCreateAndroidPaymentMutationKey = () =>
  [{ url: '/api/user/telegram/transactions/android' }] as const;

export type TelegramTransactionsUserCreateAndroidPaymentMutationKey = ReturnType<
  typeof telegramTransactionsUserCreateAndroidPaymentMutationKey
>;

/**
 * {@link /api/user/telegram/transactions/android}
 */
export function useTelegramTransactionsUserCreateAndroidPayment<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsUserControllerCreateAndroidPaymentMutationResponse,
      ResponseErrorConfig<
        | TelegramTransactionsUserControllerCreateAndroidPayment400
        | TelegramTransactionsUserControllerCreateAndroidPayment401
        | TelegramTransactionsUserControllerCreateAndroidPayment404
      >,
      { data: TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsUserCreateAndroidPaymentMutationKey();

  return useMutation<
    TelegramTransactionsUserControllerCreateAndroidPaymentMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerCreateAndroidPayment400
      | TelegramTransactionsUserControllerCreateAndroidPayment401
      | TelegramTransactionsUserControllerCreateAndroidPayment404
    >,
    { data: TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramTransactionsUserCreateAndroidPayment(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
